<template>
  <div class="className" />
</template>

<script>
import echarts from 'echarts' // echarts theme
import { debounce } from '@/utils/util'
require('echarts/theme/macarons')
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    name: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({
      time,
      userNum,
      payNum,
      sumMoney,
      payAloneMoney,
      givenMoney,
      desMoney,
      sumGiveNum,
      sumRefMoney,
    } = {}) {
      this.chart.setOption({
        // title: {
        //   text: '112',
        //   left: '5%',
        //   top: '10',
        //   textStyle: {
        //     color: '#333333',
        //     fontWeight: 'bold'
        //   }
        // },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: time,
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#333',
          },
          splitLine: {
            lineStyle: {
              color: '#44476e',
              type: 'dashed',
            },
          },
          splitArea: {
            show: false,
          },
        },
        grid: {
          show: false,
          backgroundColor: 'transparent',
          top: '5%',
          bottom: '18%',
          right: 10,
          left: '5%',
        },
        // dataZoom: [{
        //   type: 'inside',
        //   start: 40,
        //   end: 100
        // }, {
        //   start: 0,
        //   end: 10,
        //   handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        //   handleSize: '100%',
        //   handleStyle: {
        //     color: '#fff',
        //     shadowBlur: 4,
        //     shadowColor: 'rgba(0, 0, 0, 0.6)',
        //     shadowOffsetX: 2,
        //     shadowOffsetY: 2
        //   }
        // }],
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            handleSize: 0, // 滑动条的 左右2个滑动条的大小
            height: 10, // 组件高度
            left: 550, // 左边的距离
            right: 540, // 右边的距离
            bottom: 506, // 右边的距离
            handleColor: '#ddd', // h滑动图标的颜色
          },
          {
            type: 'inside',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff',
            },
          },
          {
            show: true,
            type: 'slider',
            // y: '94%',
            bottom: '0',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff',
            },
          },
        ],
        series: [
          {
            data: userNum,
            type: 'bar',
            name: '该时间操作用户数',
            label: {
              show: true,
              position: 'top',
              fontSize: '12px',
              formatter: (params) => {
                if (params.dataIndex % 5 === 0) {
                  return params.value
                } else {
                  return ''
                }
              },
            },
            itemStyle: {
              // ---图形形状
              barBorderRadius: [10, 10, 10, 10],
            },
          },
          {
            data: payNum,
            type: 'bar',
            name: '充值次数',
            label: {
              show: true,
              position: 'top',
              fontSize: '12px',
              formatter: (params) => {
                if (params.dataIndex % 5 === 0) {
                  return params.value
                } else {
                  return ''
                }
              },
            },
            itemStyle: {
              // ---图形形状
              barBorderRadius: [10, 10, 10, 10],
            },
          },
          {
            data: sumMoney,
            type: 'bar',
            name: '充值总金额',
            label: {
              show: true,
              position: 'top',
              fontSize: '12px',
              formatter: (params) => {
                if (params.dataIndex % 5 === 0) {
                  return params.value
                } else {
                  return ''
                }
              },
            },
            itemStyle: {
              // ---图形形状
              barBorderRadius: [10, 10, 10, 10],
            },
          },
          // {
          //   data: payAloneMoney,
          //   type: 'bar',
          //   name: '门店现金账户',
          //   label: {
          //     show: true,
          //     position: 'top',
          //     fontSize: '12px',
          //     formatter: (params) => {
          //       if (params.dataIndex % 5 === 0) {
          //         return params.value
          //       } else {
          //         return ''
          //       }
          //     }
          //   },
          //   itemStyle: {					// ---图形形状
          //     barBorderRadius: [10, 10, 10, 10]
          //   }
          // },
          {
            data: givenMoney,
            type: 'bar',
            name: '赠送金额',
            label: {
              show: true,
              position: 'top',
              fontSize: '12px',
              formatter: (params) => {
                if (params.dataIndex % 5 === 0) {
                  return params.value
                } else {
                  return ''
                }
              },
            },
            itemStyle: {
              // ---图形形状
              barBorderRadius: [10, 10, 10, 10],
            },
          },
          // {
          //   data: desMoney,
          //   type: 'bar',
          //   name: '指定门店赠送金额',
          //   label: {
          //     show: true,
          //     position: 'top',
          //     fontSize: '12px',
          //     formatter: (params) => {
          //       if (params.dataIndex % 5 === 0) {
          //         return params.value
          //       } else {
          //         return ''
          //       }
          //     }
          //   },
          //   itemStyle: {					// ---图形形状
          //     barBorderRadius: [10, 10, 10, 10]
          //   }
          // },
          // {
          //   data: sumGiveNum,
          //   type: 'bar',
          //   name: '合计赠送',
          //   label: {
          //     show: true,
          //     position: 'top',
          //     fontSize: '12px',
          //     formatter: (params) => {
          //       if (params.dataIndex % 5 === 0) {
          //         return params.value
          //       } else {
          //         return ''
          //       }
          //     }
          //   },
          //   itemStyle: {					// ---图形形状
          //     barBorderRadius: [10, 10, 10, 10]
          //   }
          // },
          {
            data: sumRefMoney,
            type: 'line',
            name: '退款金额',
            label: {
              show: true,
              position: 'top',
              fontSize: '12px',
              formatter: (params) => {
                if (params.dataIndex % 5 === 0) {
                  return params.value
                } else {
                  return ''
                }
              },
            },
            itemStyle: {
              // ---图形形状
              barBorderRadius: [10, 10, 10, 10],
            },
          },
        ],
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
  },
}
</script>
<style  scoped>
.className {
  width: 100%;
  height: 300px;
}
</style>
